module.exports = __webpack_public_path__ + "img/奖杯.be3408f7.gif";